module.exports = __webpack_public_path__ + "static/media/insert_comment.1b63c6ae.svg";